module.exports = __webpack_public_path__ + "static/popsuplogo.51de00a5.svg";